import React, { Component } from 'react';
import md5 from 'md5';
import firebase from '../../Firebase';
import 'firebase/auth';
import download from 'image-downloader';
import { districts } from '../constants/districts';
var fs = require('fs');
var https = require('https');


class User extends Component {
    constructor() {
        super();
        this.state = {
            response: {
                success: false,
            }
        };
    }


    updatePassword = async (user_key, password) => {
        this.UserRef = firebase.firestore().collection('users').doc(user_key);
        this.UserRef.update(
            {
                "password": password,
            }
        ).catch((error) => {
            alert(error);
            return false
        });

        return true;
    }

    comfirmUserPassword = async (username, password) => {
        this.UserRef = firebase.firestore().collection('users').where("user_name", "==", "" + username + "").where("password", "==", "" + password + "");
        return this.UserRef.get().then(async (querySnapshot) => {
            if (!querySnapshot.empty)
                return true;
            else
                return false;
        })
            .catch((error) => {
                alert(error);
                return false;
            });
    }

    matchPassword = async (newpassword, confirmpassword) => {
        if (!(newpassword === confirmpassword))
            return false;
        else
            return true;
    }

    changePassword = (oldpassword, newpassword, confirmpassword, user) => {
        const encryptedoldpassword = md5(oldpassword);
        const encryptednewpassword = md5(newpassword);
        return this.matchPassword(newpassword, confirmpassword).then((response) => {
            if (!response)
                return { success: false, error: "Passwords did not match" };
            else {
                return this.comfirmUserPassword(user.user_name, encryptedoldpassword).then((response) => {
                    if (!response)
                        return { success: false, error: "Incorrect Old Password" };
                    else {
                        return this.updatePassword(user.key, encryptednewpassword).then((response) => {
                            if (!response)
                                return { success: false, error: "Password change Failed" };
                            else {
                                return { success: true, error: null };
                            }
                        })
                            .catch((error) => {
                                alert(error);
                            });
                    }
                })
                    .catch((error) => {
                        alert(error);
                    });
            }
        })
            .catch((error) => {
                alert(error);
            });
    }

    logoutx = async () => {
        const response = this.state.response;
        try {
            const user = await localStorage.removeItem('sgdUser');
            const child = await localStorage.removeItem('sgdChild');
            const child_progress_id = await localStorage.removeItem('child_progress_id');
            firebase.auth().signOut();
            return true;
        } catch (error) {
            alert(error);
        }
    };

    getPhoto = (User) => {
        this.PhotoRef = firebase.storage().ref("profiles").child(User.user_name);
        return this.PhotoRef.getDownloadURL().then(url => {
            User.photo = url;
            // localStorage.setItem('sgdUser', JSON.stringify(User));
            return { success: true, url: url };
        })
            .catch(error => {

                switch (error.code) {
                    case 'storage/object-not-found':
                        break;

                    case 'storage/unauthorized':
                        alert("User doesn't have permission to access the object");
                        break;

                    case 'storage/canceled':
                        alert("User canceled the upload");
                        break;

                    case 'storage/unknown':
                        alert("Unknown error occurred, inspect the server response");
                        break;
                }

                return { success: false, url: null };
            });
    }

    setLastLogin = (date, key) => {
        this.UserRef = firebase.firestore().collection('users').doc(key);
        this.UserRef.update(
            {
                "last_login": date
            }
        )
    }

    setDatax = async (username, password) => {
        // username = username.toLowerCase();
        password = md5(password);

        // firebase.auth().createUserWithEmailAndPassword("smartgd@gmail.com", "SmartGD@2018!#").catch(function(error) {
        //     alert(error);
        // });


        // firebase.auth().signInWithEmailAndPassword("smartgd@gmail.com", "SmartGD@2018!#").catch(function(error) {
        //     // Handle Errors here.
        //     var errorCode = error.code;
        //     var errorMessage = error.message;

        //     if (errorCode === 'auth/wrong-password') {
        //       alert('Wrong password.');
        //     } else {
        //       alert(errorMessage);         
        //     }

        //     console.log(error);
        // });
        // alert(username);

        //Catch all collections needed for offline work
        this.UserRef = firebase.firestore().collection('users').where("user_name", "==", "" + username + "").where("password", "==", "" + password + "");
        firebase.firestore().collection("weight_for_age_boys").get();
        firebase.firestore().collection("weight_for_age_girls").get();
        firebase.firestore().collection("length_height_for_age_boys").get();
        firebase.firestore().collection("length_height_for_age_girls").get();
        firebase.firestore().collection("weight_for_length_boys").get();
        firebase.firestore().collection("weight_for_length_girls").get();
        firebase.firestore().collection("weight_for_height_boys").get();
        firebase.firestore().collection("weight_for_height_girls").get();
        //END Catch all collections needed for offline work

        let User = null;
        let Child = null;

        // get and store user info
        return this.UserRef.get().then(async (querySnapshot) => {
            if (!querySnapshot.empty) {

                let currentTime = new Date();
                let Year = currentTime.getUTCFullYear() < 10 ? "0" + currentTime.getUTCFullYear() : currentTime.getUTCFullYear();
                let Month = currentTime.getUTCMonth();
                Month += 1;
                Month = Month < 10 ? "0" + Month : Month;
                let Datex = currentTime.getUTCDate() < 10 ? "0" + currentTime.getUTCDate() : currentTime.getUTCDate();
                let Hours = currentTime.getUTCHours() < 10 ? "0" + currentTime.getUTCHours() : currentTime.getUTCHours();
                let Minutes = currentTime.getUTCMinutes() < 10 ? "0" + currentTime.getUTCMinutes() : currentTime.getUTCMinutes();
                let Seconds = currentTime.getUTCSeconds() < 10 ? "0" + currentTime.getUTCSeconds() : currentTime.getUTCSeconds();
                let currentDateTime = Year + "-" + Month + "-" + Datex + " " + Hours + ":" + Minutes + ":" + Seconds;

                querySnapshot.forEach((doc) => {
                    User = doc.data();
                    User.key = doc.id;
                });


                this.setLastLogin(currentDateTime, User.key);
                this.UserRef = firebase.firestore().collection('users').doc(User.key);

                // get and store child info
                return this.UserRef.collection('children').get().then((querySnapshot) => {
                    console.log(querySnapshot)
                    if (!querySnapshot.empty) {
                        querySnapshot.forEach((doc) => {
                            Child = doc.data();
                            Child.key = doc.id;

                            let settlement = Child.settlement;
                            settlement = districts.find((district) => {
                                return district['district_id'] === settlement;
                            });

                            Child.settlement = settlement['district_name'];
                        });

                        User.photo = null;
                        localStorage.setItem('sgdUser', JSON.stringify(User));
                        localStorage.setItem('sgdChild', JSON.stringify(Child));
                        this.state.response.success = true;
                        console.log("Fetched")
                        return true;

                    }
                    else {
                        this.state.response.success = false;
                        console.log("Failed 1")
                        return false;
                    }
                })
                    .catch((error) => {
                        alert(error);
                        this.state.response.success = false;
                        return false;
                    });
                // END get and store child info
            }
            else {
                this.state.response.success = false;
                return false;
            }
        })
            .catch((error) => {
                alert(error);
                this.state.response.success = false;
                return false;
                // alert(error);
            });
        //END get and store user info
    }

    logout = () => {
        return this.logoutx().then((response) => {
            if (!response)
                return true;
            else
                return false;
        })
            .catch((error) => {
                alert(error);
            });
    }

    setData = (username, password) => {
        return this.setDatax(username, password).then((response) => {
            if (!response)
                return this.state.response;
            else
                return this.state.response;
        })
            .catch((error) => {
                alert(error);
            });
    }

    // Fetch stored user data
    getData = async () => {
        const response = this.state.response;
        try {
            const user = JSON.parse(await localStorage.getItem('sgdUser'));
            const child = JSON.parse(await localStorage.getItem('sgdChild'));

            if (user === null) {
                response.success = false;
                this.state.response = response;
                return this.state.response;
            }
            else {

                // $dob = date_create($C_DOB);
                // $dob = date_format($dob, "M jS Y");

                const dob = new Date(child.birth_date);
                const today = new Date();

                const dobstamp = dob.getTime();
                const todaystamp = today.getTime();
                const agestamp_temp = todaystamp - dobstamp;
                const agestamp = new Date(agestamp_temp);
                var years = agestamp.getFullYear();
                years = years - 1970;
                var months = agestamp.getMonth();
                // months = months-1;
                var days = agestamp.getDate();
                days = days - 1;
                const total_days = (agestamp_temp / (1000 * 60 * 60 * 24));
                const total_months = (months) + (years * 12);
                const total_weeks = Math.floor(total_days / 7);

                const age = {
                    "years": years,
                    "months": months,
                    "days": days,
                    "total_months": total_months,
                    "total_weeks": total_weeks,
                    "total_days": total_days
                };


                const data = {
                    user: user,
                    child: child,
                    age: age
                };

                response.success = true;
                response.data = data;
                this.state.response = response;
                return this.state.response;
            }

        } catch (error) {
            alert(error);
        }
    };
    //END Fetch stored user data
}

export const UserController = new User();